import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["flowId", "onClick", "sourceApp", "tooltipProps"];
import FormattedMessage from 'I18n/components/FormattedMessage';
import { DELETE } from 'automation-ui-permissions/feature-permissions/constants/WorkflowManagementFeatures';
import { useFeaturePermission } from 'automation-ui-permissions/feature-permissions/hooks/featurePermissionHooks';
import TrackableButton from 'automation-ui-usage-tracking/components/TrackableButton';
import { useFlpAccess } from 'automation-ui-permissions/flp/hooks/useFlpAccess';
import Trackables from 'automation-ui-usage-tracking/Trackables';
import FlpRestrictedPropertiesMessage from 'automation-ui-management/components/flp/FlpRestrictedPropertiesMessage';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { jsx as _jsx } from "react/jsx-runtime";
const OpenDeleteFlowModalButton = _ref => {
  let {
      flowId,
      onClick,
      sourceApp,
      tooltipProps = {}
    } = _ref,
    buttonProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const {
    loading: loadingFlpAccess,
    data: flpAccessData,
    error: flpAccessError
  } = useFlpAccess(flowId);
  const {
    hasFeatureAccess,
    disabledFeatureMessage
  } = useFeaturePermission({
    sourceApp,
    feature: DELETE
  });
  const hasFlpAccess = !loadingFlpAccess && !flpAccessError && (flpAccessData === null || flpAccessData === void 0 ? void 0 : flpAccessData.hasAccess(DELETE));
  const isAccessDisabled = !hasFeatureAccess || !hasFlpAccess;
  const buttonContent = /*#__PURE__*/_jsx(TrackableButton, Object.assign({}, buttonProps, {
    onClick: onClick,
    trackableKey: Trackables.DELETE_WORKFLOW_CLICK,
    disabled: isAccessDisabled,
    immediate: true,
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "automation-ui-management.button.delete"
    })
  }));
  if (isAccessDisabled) {
    var _flpAccessData$flpRej;
    const disabledMessage = disabledFeatureMessage || /*#__PURE__*/_jsx(FlpRestrictedPropertiesMessage, {
      label: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "automation-ui-management.button.accessDisabled.deleteFlp"
      }),
      flpRejectionReasons: (_flpAccessData$flpRej = flpAccessData === null || flpAccessData === void 0 ? void 0 : flpAccessData.flpRejectionReasons) !== null && _flpAccessData$flpRej !== void 0 ? _flpAccessData$flpRej : []
    });
    return /*#__PURE__*/_jsx(Tooltip, Object.assign({
      placement: "right"
    }, tooltipProps, {
      title: disabledMessage,
      children: buttonContent
    }));
  } else {
    return buttonContent;
  }
};
export default OpenDeleteFlowModalButton;